module.exports = __webpack_public_path__ + "d30b2fa9f1df67bfe87b853b1bb8c887.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/warning.svg
// module id = 790
// module chunks = 0